/* MV Sortiment assets/mv-sortiment.i2.js - Agent T-I2 - 2026-10-04
 *
 * Interaktive Elemente der Produktseite (Theme-Kopie Impact 6.12.0). Teil von assets/mv-sortiment.js
 * (_build/konkat.sh), laedt allein und in beliebiger Reihenfolge mit den anderen Teilen. Kein Inline-Skript;
 * nur Delegation auf document (click, scroll in der Capture-Phase, variant:change, shopify:section:load,
 * DOMContentLoaded) sowie window pageshow (bfcache). Waechter window.__mvSortimentI2. Zustand steht im DOM:
 *   aria-pressed an .mv-groessen__modell, aria-current an [data-mv-tab] und [data-mv-highlights-dot],
 *   data-mv-groessen (aufgeloeste Formular-ID), data-mv-groessen-wahl (laufende Auswahl per Klick),
 *   data-mv-tabs-bereit, data-mv-tabs-fixiert, hidden an Eintraegen, Leiste und Hinweis.
 *
 * 1. Groessenvergleich (sections/mv-groessenvergleich.liquid)
 *    Klick auf [data-mv-groesse]: Kandidaten = data-mv-groesse-varianten (Varianten-IDs der Silhouette),
 *    Optionswert-IDs je Variante aus script[data-mv-groessen-data]. Gewaehlt wird der Kandidat mit den meisten
 *    gleichen Optionswerten wie die gewaehlten Radios (Gleichstand: erster), die Front einer Slave-Variante
 *    bleibt also erhalten. Vorher feuert mv:groesse:wahl (bubbles, abbrechbar, detail {formId, variantId,
 *    gruppe, breite, hoehe, quelle}). Dann setzt das Skript Impacts Radios input[data-option-position]
 *    [form][value] und feuert genau ein change (Impacts VariantPicker hoert per Delegate auf body); Impact laedt
 *    die Kombination, tauscht Preis, Galerie und Konfigurator und feuert variant:change am Formular.
 *    Fehlt ein Radio (Variantenwaehler aus, verbundenes Produkt): Rueckfall Navigation auf ?variant=<id>.
 *    variant:change (auch aus der Kaufbox) zieht aria-pressed nach; der Hinweis "... ist gewaehlt" erscheint
 *    nur nach eigener Auswahl und verschwindet bei einer fremden. Start und pageshow: Zustand aus den Radios.
 * 2. Highlights-Karussell (sections/mv-highlights.liquid): der Punkt folgt dem Scrollen der Liste, ein Klick
 *    auf einen Punkt scrollt zur Karte.
 * 3. Sprungleiste (sections/mv-tabs.liquid): Ziele ohne Inhalt ausblenden, unter data-mv-tabs-min Zielen die
 *    Leiste; Scroll-Spy (aria-current) mit Leseline = max(Header, Unterkante der Leiste) + 24 px, zwischen zwei
 *    Zielen ist keins aktiv; Zeiger-Klick scrollt weich (scroll-padding aus der CSS), die Tastatur behaelt den
 *    nativen Ankersprung (der Fokus folgt dem Anker).
 *
 * Impact-Rerender-Regel: Impact ersetzt beim Variantenwechsel die Bloecke der Kaufbox (product:rerender).
 * Diese Sektionen liegen ausserhalb und werden nicht ersetzt; Radios und Sprungziele werden bei jedem Zugriff
 * frisch gesucht, nie zwischengespeichert. Sichtbare Texte kommen aus dem Liquid (Settings); diese Datei bleibt
 * reines ASCII. Unter Node (Tests) liefert die Datei nur die reinen Funktionen ueber module.exports.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-04.1';

  // ===========================================================================================
  // Reine Logik (ohne DOM; unter Node per module.exports pruefbar)
  // ===========================================================================================

  function text(x) {
    return x === null || x === undefined ? '' : String(x).trim();
  }

  function idsAusText(s) {
    return text(s).split(/\s+/).filter(function (x) { return x !== ''; });
  }

  function gesetzt(x) {
    return x !== null && x !== undefined && x !== '';
  }

  // Kandidat mit den meisten gleichen Optionswerten (Position fuer Position); Gleichstand: erster Kandidat
  function besteVariante(kandidaten, aktuell) {
    var beste = null;
    var besteTreffer = -1;
    (kandidaten || []).forEach(function (k) {
      var optionen = (k && k.optionen) || [];
      var treffer = 0;
      for (var i = 0; i < optionen.length; i++) {
        var a = aktuell ? aktuell[i] : null;
        if (gesetzt(a) && gesetzt(optionen[i]) && String(optionen[i]) === String(a)) treffer += 1;
      }
      if (treffer > besteTreffer) {
        beste = k;
        besteTreffer = treffer;
      }
    });
    return beste;
  }

  // Variante, deren Optionswerte genau den gewaehlten Werten entsprechen (alle Positionen belegt)
  function varianteZuWerten(karte, werte) {
    var liste = werte || [];
    var ids = Object.keys(karte || {});
    for (var i = 0; i < ids.length; i++) {
      var o = karte[ids[i]] || [];
      if (!o.length || o.length !== liste.length) continue;
      var gleich = true;
      for (var j = 0; j < o.length; j++) {
        if (!gesetzt(liste[j]) || String(o[j]) !== String(liste[j])) {
          gleich = false;
          break;
        }
      }
      if (gleich) return ids[i];
    }
    return null;
  }

  // Ziel, das die Leseline enthaelt (top <= linie < bottom); keins -> null
  function aktiverAbschnitt(abschnitte, linie) {
    var treffer = null;
    (abschnitte || []).forEach(function (a) {
      if (a && a.top <= linie && a.bottom > linie) treffer = a.key;
    });
    return treffer;
  }

  // Index der Position, die dem Scrollwert am naechsten liegt
  function naechsterIndex(positionen, wert) {
    var beste = 0;
    var abstand = Infinity;
    (positionen || []).forEach(function (p, i) {
      var d = Math.abs(p - wert);
      if (d < abstand) {
        abstand = d;
        beste = i;
      }
    });
    return beste;
  }

  // Platzhalter {name} aus dem Setting-Text fuellen; unbekannte bleiben stehen
  function fuelleText(vorlage, werte) {
    return text(vorlage).replace(/\{(\w+)\}/g, function (ganz, name) {
      return werte && Object.prototype.hasOwnProperty.call(werte, name) ? String(werte[name]) : ganz;
    });
  }

  var logik = {
    VERSION: VERSION,
    idsAusText: idsAusText,
    besteVariante: besteVariante,
    varianteZuWerten: varianteZuWerten,
    aktiverAbschnitt: aktiverAbschnitt,
    naechsterIndex: naechsterIndex,
    fuelleText: fuelleText
  };

  // Exportfenster nur unter Node (kein window): Tests laden die Datei als Skript mit module-Objekt
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  // ===========================================================================================
  // Browser
  // ===========================================================================================

  if (window.__mvSortimentI2) return;
  var api = window.__mvSortimentI2 = {
    version: VERSION,
    logik: logik,
    // Rueckfall ohne Radios: Seite mit der Variante laden (Tests ersetzen die Funktion)
    navigiere: function (url) { window.location.assign(url); }
  };
  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (!MV.i2) MV.i2 = api;

  function alsListe(x) {
    return Array.prototype.slice.call(x || []);
  }

  function attr(wert) {
    return String(wert).replace(/["\\]/g, '\\$&');
  }

  function zahl(x) {
    var n = parseInt(x, 10);
    return isFinite(n) ? n : null;
  }

  function sanft() {
    return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function scrolle(el, block) {
    if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView({ behavior: sanft() ? 'smooth' : 'auto', block: block });
  }

  // ---------------------------------------------------------------- 1. Groessenvergleich

  function leseDaten(root) {
    var s = root.querySelector('script[data-mv-groessen-data]');
    var d = null;
    try {
      d = JSON.parse(s ? s.textContent : 'null');
    } catch (e) {
      d = null;
    }
    return d && typeof d === 'object' && d.varianten && typeof d.varianten === 'object' ? d : { varianten: {} };
  }

  // Formular-ID aus dem Liquid; gibt es das Formular nicht (Sektion main heisst anders), ueber variant-picker[handle]
  function formularId(root) {
    var id = root.getAttribute('data-mv-groessen') || '';
    if (id && document.getElementById(id)) return id;
    var handle = root.getAttribute('data-mv-groessen-produkt');
    var picker = handle ? document.querySelector('variant-picker[handle="' + attr(handle) + '"][form-id]') : null;
    var neu = picker ? picker.getAttribute('form-id') : '';
    if (neu && neu !== id) root.setAttribute('data-mv-groessen', neu);
    return neu || id;
  }

  function aktuelleWerte(formId) {
    var werte = [];
    alsListe(document.querySelectorAll('input[data-option-position][form="' + attr(formId) + '"]:checked')).forEach(function (r) {
      var p = zahl(r.getAttribute('data-option-position'));
      if (p && p > 0) werte[p - 1] = r.value;
    });
    return werte;
  }

  // aria-pressed nachziehen; liefert den gedrueckten Knopf
  function setzeAktiv(root, variantId) {
    var gedrueckt = null;
    alsListe(root.querySelectorAll('[data-mv-groesse]')).forEach(function (k) {
      var an = gesetzt(variantId) && idsAusText(k.getAttribute('data-mv-groesse-varianten')).indexOf(String(variantId)) !== -1;
      k.setAttribute('aria-pressed', an ? 'true' : 'false');
      if (an && !gedrueckt) gedrueckt = k;
    });
    return gedrueckt;
  }

  // Hinweis "<Modell> ist gewaehlt ..." zeigen (mit Knopf) oder verbergen (ohne)
  function hinweis(root, knopf) {
    var box = root.querySelector('[data-mv-groessen-hinweis]');
    if (!box) return;
    if (!knopf) {
      box.hidden = true;
      return;
    }
    var feld = root.querySelector('[data-mv-groessen-hinweis-text]');
    var titel = knopf.querySelector('[data-mv-groesse-titel]');
    if (feld) feld.textContent = fuelleText(root.getAttribute('data-mv-groessen-text') || '{modell}', { modell: titel ? text(titel.textContent) : '' });
    box.hidden = false;
  }

  function variantenUrl(root, variantId) {
    var basis = root.getAttribute('data-mv-groessen-url') || window.location.pathname;
    return basis + (basis.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(variantId);
  }

  function waehle(knopf) {
    var root = knopf.closest('[data-mv-groessen]');
    if (!root) return;
    var formId = formularId(root);
    var daten = leseDaten(root);
    var kandidaten = idsAusText(knopf.getAttribute('data-mv-groesse-varianten')).map(function (id) {
      return { id: id, optionen: daten.varianten[id] || [] };
    });
    var beste = besteVariante(kandidaten, aktuelleWerte(formId));
    if (!beste) return;

    var ereignis = new CustomEvent('mv:groesse:wahl', { bubbles: true, cancelable: true, detail: {
      formId: formId,
      variantId: beste.id,
      gruppe: knopf.getAttribute('data-mv-groesse'),
      breite: zahl(knopf.getAttribute('data-mv-groesse-breite')),
      hoehe: zahl(knopf.getAttribute('data-mv-groesse-hoehe')),
      quelle: 'klick'
    } });
    if (!root.dispatchEvent(ereignis)) return;

    // Radios der Variante suchen; jede Position muss ein bedienbares Radio haben
    var radios = [];
    var vollstaendig = beste.optionen.length > 0 && beste.optionen.every(function (wert, i) {
      if (!gesetzt(wert)) return false;
      var r = document.querySelector('input[data-option-position="' + (i + 1) + '"][form="' + attr(formId) + '"][value="' + attr(wert) + '"]');
      if (!r || r.disabled || r.hasAttribute('data-product-url')) return false;
      radios.push(r);
      return true;
    });

    setzeAktiv(root, beste.id);
    if (!vollstaendig) {
      api.navigiere(variantenUrl(root, beste.id));
      return;
    }
    var geaendert = radios.filter(function (r) { return !r.checked; });
    if (!geaendert.length) {
      hinweis(root, knopf);
      return;
    }
    root.setAttribute('data-mv-groessen-wahl', beste.id);
    geaendert.forEach(function (r) { r.checked = true; });
    geaendert[geaendert.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
  }

  function zurKaufbox(root) {
    var formId = formularId(root);
    var f = attr(formId);
    var ziel = document.querySelector('[data-mv-preis="' + f + '"]') ||
      document.querySelector('[data-mv-optionen="' + f + '"]') ||
      document.querySelector('variant-picker[form-id="' + f + '"]') ||
      document.getElementById('mv-konfigurator') ||
      document.getElementById(formId);
    if (!ziel) return;
    scrolle(ziel, 'center');
    var radio = document.querySelector('input[data-option-position="1"][form="' + f + '"]:checked');
    if (radio && typeof radio.focus === 'function') {
      try {
        radio.focus({ preventScroll: true });
      } catch (e) {
        radio.focus();
      }
    }
  }

  function initGroessen(root) {
    var formId = formularId(root);
    var werte = aktuelleWerte(formId);
    if (!werte.length) return;
    var vid = varianteZuWerten(leseDaten(root).varianten, werte);
    if (vid) setzeAktiv(root, vid);
  }

  // Impact feuert variant:change (bubbles) am Formular; detail.formId ist dort das Hidden-Input, daher event.target
  document.addEventListener('variant:change', function (e) {
    var form = e.target;
    var formId = form && form.getAttribute ? form.getAttribute('id') : null;
    if (!formId) return;
    var d = e.detail || {};
    var vid = d.variant && gesetzt(d.variant.id) ? String(d.variant.id) : null;
    alsListe(document.querySelectorAll('[data-mv-groessen]')).forEach(function (root) {
      if (formularId(root) !== formId) return;
      var knopf = setzeAktiv(root, vid);
      var wahl = root.getAttribute('data-mv-groessen-wahl');
      root.removeAttribute('data-mv-groessen-wahl');
      hinweis(root, wahl && vid === wahl ? knopf : null);
    });
  });

  // ---------------------------------------------------------------- 2. Highlights-Karussell

  function setzePunkt(root, index) {
    alsListe(root.querySelectorAll('[data-mv-highlights-dot]')).forEach(function (p, i) {
      if (i === index) p.setAttribute('aria-current', 'true');
      else p.removeAttribute('aria-current');
    });
  }

  function punktNachScroll(liste) {
    var root = liste.closest('[data-mv-highlights]');
    var karten = alsListe(liste.children);
    if (!root || !karten.length) return;
    var start = karten[0].offsetLeft;
    setzePunkt(root, naechsterIndex(karten.map(function (k) { return k.offsetLeft - start; }), liste.scrollLeft));
  }

  function zuKarte(punkt) {
    var root = punkt.closest('[data-mv-highlights]');
    var liste = root ? root.querySelector('[data-mv-highlights-liste]') : null;
    if (!liste) return;
    var karten = alsListe(liste.children);
    var i = (zahl(punkt.getAttribute('data-mv-highlights-dot')) || 1) - 1;
    if (!karten[i]) return;
    var links = karten[i].offsetLeft - karten[0].offsetLeft;
    if (typeof liste.scrollTo === 'function') liste.scrollTo({ left: links, behavior: sanft() ? 'smooth' : 'auto' });
    else liste.scrollLeft = links;
    setzePunkt(root, i);
  }

  // ---------------------------------------------------------------- 3. Sprungleiste

  var INHALT = 'h1, h2, h3, h4, p, li, table, dl, summary, img, figure';

  function hatInhalt(el) {
    return !!el && !el.hidden && el.querySelector(INHALT) !== null;
  }

  function tabZiel(link) {
    var id = text(link.getAttribute('href')).replace(/^#/, '');
    var el = id ? document.getElementById(id) : null;
    if (!el) {
      var key = text(link.getAttribute('data-mv-tab')).replace(/[^\w-]/g, '');
      el = key ? document.querySelector('[id^="shopify-section-"][id$="__' + key + '"]') : null;
      if (el) link.setAttribute('href', '#' + el.id);
    }
    return el;
  }

  function initTabs(nav) {
    var sichtbar = 0;
    alsListe(nav.querySelectorAll('[data-mv-tab]')).forEach(function (link) {
      var ok = hatInhalt(tabZiel(link));
      var eintrag = link.closest('li') || link;
      eintrag.hidden = !ok;
      if (ok) sichtbar += 1;
    });
    nav.hidden = sichtbar < (zahl(nav.getAttribute('data-mv-tabs-min')) || 2);
    nav.setAttribute('data-mv-tabs-bereit', '');
  }

  function cssZahl(stil, name) {
    var n = parseFloat(stil.getPropertyValue(name));
    return isFinite(n) ? n : 0;
  }

  // Hoehe des klebenden Kopfbereichs wie Impacts --sticky-area-height (Header plus ggf. Ankuendigungsleiste)
  function kopfHoehe() {
    var stil = window.getComputedStyle(document.documentElement);
    var sichtbar = text(stil.getPropertyValue('--header-is-visible'));
    var faktor = sichtbar === '' ? 1 : cssZahl(stil, '--header-is-visible');
    return faktor * (cssZahl(stil, '--sticky-header-enabled') * cssZahl(stil, '--header-height') +
      cssZahl(stil, '--sticky-announcement-bar-enabled') * cssZahl(stil, '--announcement-bar-height'));
  }

  function spy(nav) {
    if (nav.hidden) return;
    var links = alsListe(nav.querySelectorAll('[data-mv-tab]'));
    var rand = nav.getBoundingClientRect();
    var kopf = kopfHoehe();
    var linie = Math.max(kopf, rand.bottom) + 24;
    var abschnitte = [];
    links.forEach(function (link, i) {
      if ((link.closest('li') || link).hidden) return;
      var ziel = tabZiel(link);
      if (!ziel) return;
      var r = ziel.getBoundingClientRect();
      abschnitte.push({ key: i, top: r.top, bottom: r.bottom });
    });
    var aktiv = aktiverAbschnitt(abschnitte, linie);
    links.forEach(function (link, i) {
      if (i === aktiv) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    if (nav.classList.contains('mv-tabs--sticky') && rand.top <= kopf + 1 && rand.bottom > kopf) nav.setAttribute('data-mv-tabs-fixiert', '');
    else nav.removeAttribute('data-mv-tabs-fixiert');
    // aktiven Eintrag in der waagrecht scrollenden Liste sichtbar halten, ohne die Seite zu bewegen
    var liste = nav.querySelector('[role="list"]');
    var aktivLink = aktiv === null ? null : links[aktiv];
    if (liste && aktivLink && liste.scrollWidth > liste.clientWidth) {
      liste.scrollLeft = Math.max(0, aktivLink.offsetLeft - (liste.clientWidth - aktivLink.offsetWidth) / 2);
    }
  }

  var spyGeplant = false;
  function planeSpy() {
    if (spyGeplant) return;
    spyGeplant = true;
    var lauf = function () {
      spyGeplant = false;
      alsListe(document.querySelectorAll('[data-mv-tabs]')).forEach(spy);
    };
    if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(lauf);
    else setTimeout(lauf, 16);
  }

  // ---------------------------------------------------------------- Delegation

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var knopf = t.closest('[data-mv-groesse]');
    if (knopf) {
      waehle(knopf);
      return;
    }
    var kaufbox = t.closest('[data-mv-groessen-kaufbox]');
    if (kaufbox) {
      var root = kaufbox.closest('[data-mv-groessen]');
      if (root) zurKaufbox(root);
      return;
    }
    var punkt = t.closest('[data-mv-highlights-dot]');
    if (punkt) {
      zuKarte(punkt);
      return;
    }
    var tab = t.closest('[data-mv-tab]');
    // nur Zeiger-Klicks weich scrollen; Tastatur (detail 0) und Klicks mit Zusatztaste bleiben nativ
    if (tab && e.detail > 0 && e.button === 0 && !e.defaultPrevented && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
      var ziel = tabZiel(tab);
      if (ziel && typeof ziel.scrollIntoView === 'function') {
        e.preventDefault();
        scrolle(ziel, 'start');
      }
    }
  });

  // scroll bubbelt nicht: Capture auf document faengt Seite und Karussell-Listen
  document.addEventListener('scroll', function (e) {
    var ziel = e.target;
    if (ziel && ziel.nodeType === 1 && ziel.hasAttribute('data-mv-highlights-liste')) {
      punktNachScroll(ziel);
      return;
    }
    if (ziel === document || ziel === document.documentElement || ziel === document.body) planeSpy();
  }, { capture: true, passive: true });

  function initAlle() {
    alsListe(document.querySelectorAll('[data-mv-groessen]')).forEach(initGroessen);
    alsListe(document.querySelectorAll('[data-mv-tabs]')).forEach(initTabs);
    alsListe(document.querySelectorAll('[data-mv-highlights-liste]')).forEach(punktNachScroll);
    planeSpy();
  }

  document.addEventListener('shopify:section:load', initAlle);
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) initAlle();
  });

  api.initialisieren = initAlle;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAlle);
  else initAlle();
})();
